module.exports = __webpack_public_path__ + "img/food-force-reports.24946247.webp";